export const NOTIFICATION_CHANNELS = [
  {
    value: 'whatsapp',
    label: 'WhatsApp',
    description: 'Instant outreach via WhatsApp automation',
    accent: '#25D366'
  },
  {
    value: 'sms',
    label: 'SMS',
    description: 'Carrier-grade fallback through BulkSMS',
    accent: '#2E86AB'
  },
  {
    value: 'email',
    label: 'Email',
    description: 'Stylized TapLearnGo invitation email',
    accent: '#6C63FF'
  }
];

export const DEFAULT_NOTIFICATION_STRATEGY = NOTIFICATION_CHANNELS.map(channel => channel.value);
